/**
 * Nerivio n-level-menu JS
 */

/* eslint-disable */
(function nLevelMenuComp($, Drupal) {
  Drupal.behaviors.myModule = {
    attach: function (context, settings) {

      function menuJS() {
        // For desktop screen only mouseenter is there.
        if (window.matchMedia("(min-width: 1024px)").matches) {
          $('.n-level .li-menu.haschild', context)
          .on('mouseenter', function () {
            $(this).addClass("expand");
          })
          .on('mouseleave', function () {
            if ($(this).hasClass("expand")) {
              $(this).removeClass("expand");
            }
          });
        } else {
          // For mobile screen only click is there.
          $('.n-level .li-menu.haschild').on('click', function(e) {
            e.stopPropagation();
            $(this).closest('.n-level').find('.n-level .li-menu.haschild.expand').not(this).removeClass('expand');
            if ($(this).hasClass('expand')) {
              $(this).next('.n-level').slideUp();
              $(this).removeClass('expand');
            } else {
              $(this).addClass('expand');
              $(this).next('.n-level').slideDown();
            }
          });
        }
      }
    menuJS();
    }
  };
})(jQuery, Drupal);
